module.exports = __webpack_public_path__ + "img/android-app-icon-step-2.2ec84579.png";